module.exports = __webpack_public_path__ + "static/media/footer_ico_consulting_disable.0241c96b.svg";